var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div form-group col-split=\"3\" ng-repeat=\"v in $ctrl.filter.verbs\" label=\"{{::v|titlecase}}\"><div class=\"input-group\"><input class=\"form-control text-right\" type=\"number\" ng-model-options=\"{updateOn: 'blur change', debounce: 350}\" ng-change=\"$ctrl.filter.search()\" verb=\"{{::v}}\" field-name=\"{{::v + $ctrl.filter.fieldName}}\" ng-model=\"$ctrl.filter.query.criteria[v + $ctrl.filter.fieldName]\"/></div></div>";
var id1="auto-query-number-filter.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;